const WEB_SDK_PREVIEW_VERSION = 'WEB_SDK_PREVIEW_VERSION';

function getUrlQueryParam(key: string) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
}

function getLocalStorageValue(key: string) {
  let item = null;
  if (window && window.localStorage) {
    item = window.localStorage.getItem(key);
  }

  return item;
}

function setLocalStorageValue(key: string, value: any) {
  if (window && window.localStorage) {
    window.localStorage.setItem(key, value);
  }
}

// Depending on query param load the correct bundle file.
function initLauncher() {
  console.log('[Launcher]: Started Web SDK Launcher');
  const version =
    getUrlQueryParam('version') ||
    getLocalStorageValue(WEB_SDK_PREVIEW_VERSION);

  const script = document.createElement('script');
  script.setAttribute('id', 'app');
  script.type = 'text/javascript';
  script.src = `${process.env.PUBLIC_PATH}index.js`;

  if (version) {
    setLocalStorageValue(WEB_SDK_PREVIEW_VERSION, version);
    // Only load the versioned mode when we are not in development, to allow development on features with the versions
    if (process.env.NODE_ENV !== 'development') {
      script.src = `${process.env.PUBLIC_PATH}versions/${version}/index.js`;
    }
    console.log('[Launcher] You are running non stable version: ', version);
  }

  document.body.appendChild(script);
}

initLauncher();
